export function cleanMobileInput(raw: string): string {
  return (raw || '').trim().replace(/[\s\-().]/g, '');
}

export function normalizeNlMobileToE164(raw: string): string | null {
  if (!raw) {
    return null;
  }

  let value = cleanMobileInput(raw);

  if (/^\+316\d{8}$/.test(value)) {
    return value;
  }

  if (/^00316\d{8}$/.test(value)) {
    return '+' + value.slice(2);
  }

  if (/^0?6\d{8}$/.test(value)) {
    const nationalNumber = value.startsWith('0') ? value.slice(1) : value;
    return '+31' + nationalNumber;
  }

  return null;
}

export function phoneRegistryDocIdFromE164(e164: string): string {
  // Use digits-only E.164 as document id (e.g. +31612345678 -> 31612345678).
  return String(e164 || '').trim().replace(/^\+/, '').replace(/\D/g, '');
}

export function normalizeMobileForRegistry(rawMobile: string): string | null {
  const cleaned = cleanMobileInput(String(rawMobile || ''));
  return normalizeNlMobileToE164(cleaned);
}
